import uuid from "react-uuid";
import { questionTypes } from "../../constants/QuestionType";
import { findIndex } from "../../functions";
import { ActionTypes } from "../constants/ActionTypes";

var initialState = {
    currentForm: null,
    trial: false,
    questions: null,
    // defaultQuestion: {
    //     id: uuid(),
    //     questionTitle: "Text Question 1",
    //     questionType: questionTypes.PARAGRAPH,
    //     required: true,
    // },
    responses: null,
    currentTheme: null,
    forms: [],
    message: "",
    viewerForm: {}

}

const formReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_CURRENT_FORM:
            return { ...state, currentForm: payload }

        case ActionTypes.FETCH_ALL_FORMS_ATTEMPT:
            return { ...state, trial: true, forms: [], message: "" }

        case ActionTypes.FETCH_ALL_FORMS_SUCCESS:
            return { ...state, trial: false, forms: payload, message: "" }

        case ActionTypes.FETCH_ALL_FORMS_FAIL:
            return { ...state, trial: false, forms: [], message: payload }

        case ActionTypes.FETCH_ALL_QUESTIONS_ATTEMPT:
            return { ...state, trial: true, message: "" }

        case ActionTypes.FETCH_ALL_QUESTIONS_SUCCESS:
            return { ...state, trial: true, message: "" }

        case ActionTypes.UPDATE_FORM:
            const index = findIndex(state?.currentForm?.id, state.forms)
            let new_forms = [...state.forms]; //making a new array

            new_forms[index] = state.currentForm; //

            return { ...state, forms: new_forms }

        case ActionTypes.ADD_QUESTION:
            if (state.currentForm) {
                return {
                    ...state,
                    currentForm: { ...state.currentForm, questions: [...state.currentForm.questions, payload] },
                }
            }
            return {
                ...state
            };

        case ActionTypes.UPDATE_QUESTIONS:
            if (state.currentForm) {
                return {
                    ...state,
                    currentForm: { ...state.currentForm, questions: payload },
                }
            }
            return {
                ...state
            };

        case ActionTypes.REMOVE_QUESTION:
            if (state.currentForm) {
                return {
                    ...state, currentForm: { ...state.currentForm, questions: state.currentForm.questions.filter(question => question.id !== payload.id) }
                }
            }
            return { ...state }

        case ActionTypes.REORDER_QUESTIONS:

            if (state.currentForm) {
                let new_curr_form = { ...state.currentForm, questions: payload }
                // console.log(new_forms)
                return { ...state, currentForm: new_curr_form }
            }
            return { ...state }

        case ActionTypes.TOGGLE_FORM_VISIBILITY:            //making a new array
            state.forms[findIndex(payload, state.forms)]["visibility"] = !state.forms[findIndex(payload, state.forms)]["visibility"]  //

            return { ...state }

        case ActionTypes.UPDATE_FORM_DETAILS:
            let newForm = structuredClone(state?.currentForm)
            newForm.formTitle = payload.formTitle;
            newForm.description = payload.description;
            newForm.formMetadata.theme = payload.theme;
            newForm.formMetadata.visibility = payload.visibility;



            return { ...state, currentForm: newForm }

        case ActionTypes.UPDATE_THEME:
            return { ...state, currentTheme: payload }



        case ActionTypes.VIEW_SINGLE_FORM:

            if (state?.forms[findIndex(payload.id, state.forms)] && state?.forms[findIndex(payload.id, state.forms)]["visibility"]) {
                const viewerForm = state?.forms?.filter(form => form.id == payload.id)
                const { responses, status, surveyor, surveyoremail, mobileNumber, visibility, ...otherDetails } = viewerForm[0]

                return { ...state, viewerForm: otherDetails }

            }

            return { viewerForm: null }



        default:
            return state
    }
}


export default formReducer